import React from 'react';
import { Box, Typography } from '@mui/material';
import { Shield } from 'lucide-react';
import tokens from '../../theme/tokens';

const Logo = ({ 
  size = 'medium', 
  showText = true, 
  color = tokens.colors.primary.main,
  onClick,
  sx = {}
}) => {
  const sizes = {
    small: { icon: 20, text: '1rem' },
    medium: { icon: 28, text: '1.125rem' },
    large: { icon: 32, text: '1.25rem' }
  };

  const currentSize = sizes[size];

  return (
    <Box 
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        cursor: onClick ? 'pointer' : 'default',
        '&:hover .logo-icon': onClick ? {
          transform: 'scale(1.1)',
        } : {},
        ...sx
      }}
      onClick={onClick}
    >
      <Shield 
        color={color}
        strokeWidth={2}
        size={currentSize.icon}
        style={{
          transition: 'transform 0.2s',
        }}
        className="logo-icon"
      />
      {showText && (
        <Typography
          variant="h6"
          sx={{
            color: tokens.colors.neutral[900],
            fontWeight: tokens.typography.fontWeights.semibold,
            fontSize: currentSize.text,
            letterSpacing: '-0.02em',
          }}
        >
          privacv
        </Typography>
      )}
    </Box>
  );
};

export default Logo; 